/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroup
 */
export interface UserGroup {
    /**
     * 
     * @type {string}
     * @memberof UserGroup
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof UserGroup
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserGroup
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof UserGroup
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof UserGroup
     */
    assignedUserCount: number;
    /**
     * 
     * @type {number}
     * @memberof UserGroup
     */
    assignedVehicleGroupCount: number;
}

/**
 * Check if a given object implements the UserGroup interface.
 */
export function instanceOfUserGroup(value: object): value is UserGroup {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('assignedUserCount' in value) || value['assignedUserCount'] === undefined) return false;
    if (!('assignedVehicleGroupCount' in value) || value['assignedVehicleGroupCount'] === undefined) return false;
    return true;
}

export function UserGroupFromJSON(json: any): UserGroup {
    return UserGroupFromJSONTyped(json, false);
}

export function UserGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'label': json['label'],
        'assignedUserCount': json['assignedUserCount'],
        'assignedVehicleGroupCount': json['assignedVehicleGroupCount'],
    };
}

export function UserGroupToJSON(json: any): UserGroup {
    return UserGroupToJSONTyped(json, false);
}

export function UserGroupToJSONTyped(value?: UserGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'label': value['label'],
        'assignedUserCount': value['assignedUserCount'],
        'assignedVehicleGroupCount': value['assignedVehicleGroupCount'],
    };
}

